// ================================================================
//  O.W.L. — Other Way Living  |  Shopify Theme JS
//  Cart uses Shopify AJAX Cart API (no token needed)
// ================================================================

// ─── SHOPIFY AJAX CART ───────────────────────────────────────

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function cartAdd(variantId) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.description || 'Could not add to cart');
  }
  return getCart();
}

async function cartChangeLine(line, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity }),
  });
  return res.json();
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ─── CART UI ─────────────────────────────────────────────────

function renderCart(cart) {
  const badge   = document.getElementById('cart-badge');
  const totalEl = document.getElementById('cart-total');
  const footer  = document.getElementById('cart-footer');
  const items   = document.getElementById('cart-items');

  badge.textContent = cart.item_count;
  badge.classList.toggle('visible', cart.item_count > 0);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  if (footer)  footer.style.display = cart.item_count > 0 ? 'block' : 'none';

  if (!items) return;

  if (cart.items.length === 0) {
    items.innerHTML = `
      <div class="cart-empty">
        <svg width="48" height="48" viewBox="0 0 72 72" fill="none" opacity="0.25">
          <ellipse cx="36" cy="44" rx="20" ry="22" fill="none" stroke="#5c7a5c" stroke-width="2.5"/>
          <ellipse cx="36" cy="24" rx="16" ry="14" fill="none" stroke="#5c7a5c" stroke-width="2.5"/>
          <circle cx="29" cy="23" r="5.5" fill="#d4a832"/>
          <circle cx="43" cy="23" r="5.5" fill="#d4a832"/>
          <circle cx="29" cy="23" r="3"   fill="#2a2520"/>
          <circle cx="43" cy="23" r="3"   fill="#2a2520"/>
        </svg>
        <div class="cart-empty-title">Your cart is empty</div>
        <div class="cart-empty-sub">Add something worth carrying.</div>
      </div>`;
    return;
  }

  items.innerHTML = cart.items.map((item, idx) => {
    const lineNum  = idx + 1;
    const imgUrl   = item.image ? item.image.replace(/(\.\w+)$/, '_120x120$1') : '';
    const variant  = item.variant_title && item.variant_title !== 'Default Title'
                     ? `<div class="cart-item-variant">${item.variant_title}</div>` : '';
    return `
      <div class="cart-item">
        <div class="cart-item-img">
          ${imgUrl ? `<img src="${imgUrl}" alt="${item.product_title}">` : ''}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          ${variant}
          <div class="cart-item-price">${formatMoney(item.price)} each</div>
          <div class="cart-item-actions">
            <button class="qty-btn" onclick="updateLine(${lineNum}, ${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="updateLine(${lineNum}, ${item.quantity + 1})">+</button>
            <button class="remove-btn" onclick="updateLine(${lineNum}, 0)">Remove</button>
          </div>
        </div>
      </div>`;
  }).join('');
}

// ─── CART ACTIONS ─────────────────────────────────────────────

async function handleAddToCart(btn) {
  const variantId = btn.dataset.variantId;
  const title     = btn.dataset.title;
  if (!variantId) return;

  btn.textContent = '...';
  btn.disabled    = true;

  try {
    const cart = await cartAdd(variantId);
    renderCart(cart);
    openCart();
    showToast(`${title} added to cart`, '🦉');
  } catch (e) {
    showToast(e.message, '⚠');
  } finally {
    btn.textContent = 'Add to Cart';
    btn.disabled    = false;
  }
}

async function updateLine(line, quantity) {
  try {
    const cart = await cartChangeLine(line, quantity);
    renderCart(cart);
  } catch (e) {
    showToast('Could not update cart', '⚠');
  }
}

function proceedToCheckout() {
  window.location.href = '/checkout';
}

// ─── CART DRAWER OPEN / CLOSE ─────────────────────────────────

function openCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

// ─── COLLECTION ACCORDION ─────────────────────────────────────
// Opens to show ALL products. If the full grid is taller than ~72% of the
// viewport, it becomes a scrollable box (capped height + overflow) so long
// categories don't take over the page; shorter ones expand to fit exactly.

function _collectionCap() {
  return Math.max(360, Math.round(window.innerHeight * 0.72));
}

function _sizeOpenGrid(grid) {
  const cap  = _collectionCap();
  const full = grid.scrollHeight;
  if (full > cap) {
    grid.style.maxHeight = cap + 'px';
    grid.style.overflowY = 'auto';
  } else {
    grid.style.maxHeight = full + 'px';
    grid.style.overflowY = '';
  }
}

function toggleCollection(id) {
  const item = document.querySelector(`[data-collection="${id}"]`);
  const grid = document.getElementById(`grid-${id}`);
  if (!item || !grid) return;
  const isOpen = item.classList.contains('open');
  item.classList.toggle('open', !isOpen);
  grid.classList.toggle('open', !isOpen);
  if (!isOpen) {
    _sizeOpenGrid(grid);
  } else {
    grid.style.maxHeight = '';
    grid.style.overflowY = '';
  }
}

// Re-measure any open collection on resize / orientation change so it keeps
// the right height and scroll behaviour after the layout reflows.
window.addEventListener('resize', () => {
  document.querySelectorAll('.collection-grid-wrap.open').forEach(_sizeOpenGrid);
});

// ─── FAQ ACCORDION ────────────────────────────────────────────

function toggleFaq(btn) {
  const item   = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ─── MOBILE MENU ──────────────────────────────────────────────

function toggleMobileMenu() {
  document.getElementById('mobile-menu').classList.toggle('open');
  document.getElementById('hamburger').classList.toggle('open');
}
function closeMobileMenu() {
  document.getElementById('mobile-menu').classList.remove('open');
  document.getElementById('hamburger').classList.remove('open');
}

// ─── TOAST ────────────────────────────────────────────────────

function showToast(msg, icon = '✓') {
  const container = document.getElementById('toast-container');
  const toast     = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `<span class="toast-icon">${icon}</span><span>${msg}</span>`;
  container.appendChild(toast);
  requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('show')));
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}

// ─── CONTACT FORM ─────────────────────────────────────────────

function submitContact(e) {
  // Shopify handles form submission natively via {% form 'contact' %}
  // This is only called if JS intercept is needed
  const successEl = document.getElementById('contact-success');
  if (successEl) {
    e.preventDefault();
    showToast("Message sent! We'll be in touch soon.", '✉');
    successEl.style.display = 'block';
    e.target.reset();
  }
}

// ─── NEWSLETTER ───────────────────────────────────────────────

function newsletterSignup(e) {
  e.preventDefault();
  const input = e.target.previousElementSibling;
  if (input && input.value) {
    showToast('Welcome to the Flock!', '🦉');
    input.value = '';
  }
}

// ─── CHECKOUT SURVEY ──────────────────────────────────────────
// Optional cart-drawer survey. Answers save as cart attributes and show on
// the order in admin (Additional details) for audience/source analysis.

function owlSaveSurvey() {
  const src = document.getElementById('owl-q-source');
  const age = document.getElementById('owl-q-age');
  const who = document.getElementById('owl-q-for');
  const attrs = {};
  if (src && src.value) attrs['Found us via'] = src.value;
  if (age && age.value) attrs['Age range'] = age.value;
  if (who && who.value) attrs['Shopping for'] = who.value;
  if (!Object.keys(attrs).length) return;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs }),
  }).catch(() => {});
}

// ─── PREDICTIVE SEARCH ────────────────────────────────────────
// Live product suggestions via Shopify's /search/suggest.json.
// Pressing Enter always falls back to the full /search results page.

(function () {
  const input = document.getElementById('owl-search-input');
  const box   = document.getElementById('owl-search-suggest');
  if (!input || !box) return;
  let timer;

  function hide() { box.hidden = true; box.innerHTML = ''; }

  function render(products) {
    if (!products.length) {
      box.innerHTML = '<div class="owl-ss-empty">No matches — press Enter to search everything</div>';
      box.hidden = false;
      return;
    }
    box.innerHTML = products.map(p => {
      const img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      return `<a href="${p.url}">`
        + `<img src="${img}" alt="" loading="lazy">`
        + `<span class="owl-ss-title">${p.title}</span></a>`;
    }).join('');
    box.hidden = false;
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(() => {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6'
        + '&resources[options][unavailable_products]=last')
        .then(r => r.json())
        .then(d => {
          const products = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(products);
        })
        .catch(hide);
    }, 220);
  });

  input.addEventListener('keydown', e => { if (e.key === 'Escape') hide(); });
  document.addEventListener('click', e => {
    const wrap = input.closest('.nav-search');
    if (wrap && !wrap.contains(e.target)) hide();
  });
})();

// ─── NAVBAR SCROLL ────────────────────────────────────────────

window.addEventListener('scroll', () => {
  document.getElementById('navbar').classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

// ─── SCROLL ANIMATIONS ────────────────────────────────────────

const _observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.fade-up').forEach(el => _observer.observe(el));

// ─── LOADING SCREEN ───────────────────────────────────────────

window.addEventListener('load', () => {
  setTimeout(() => document.getElementById('loading').classList.add('hidden'), 1600);
  // Initialise cart count from Shopify session
  getCart().then(renderCart).catch(() => {});
});
